module.exports = __webpack_public_path__ + "static/media/typewriter.354904b9.svg";